import React, { PropsWithChildren } from 'react'
import { toast } from '@workwhile/ui'
import { createContext } from 'lib/createContext'
import { useRemoveRuleJurisdictionMutation } from 'queries/wage/useRemoveRuleJurisdictionMutation'

type DetachJurisdictionFlowContextState = {
  actions: {
    detach: (jurisdictionId: number) => void
  }
}

const [Context, useDetachJurisdictionFlowContextValue] =
  createContext<DetachJurisdictionFlowContextState>({
    name: 'DetachJurisdictionFlowContext',
  })

export const DetachJurisdictionFlowProvider = ({
  children,
  ruleId,
}: PropsWithChildren<{ ruleId: number }>) => {
  const { mutate: removeJurisdiction } =
    useRemoveRuleJurisdictionMutation(ruleId)

  const value: DetachJurisdictionFlowContextState = {
    actions: {
      detach: (jurisdictionId: number) =>
        removeJurisdiction(
          { ruleId, jurisdictionId },
          {
            onSuccess: () =>
              toast.success('Jurisdiction detached', {
                position: 'top-center',
              }),
          }
        ),
    },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useDetachJurisdictionFlowContextValue }
